<template>
  <v-dialog v-model="dialogs.languageSkills.show" persistent max-width="700px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Add Language Skill</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formLanguageSkills" v-model="formValidationLangSkill">
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  v-model="dialogs.languageSkills.data.language"
                  label="Language*"
                  :items="getNotAlreadySelectedSkills()"
                  color="companyPrimary"
                  :rules="[rules.required]"
                  @change="checkLangCertificate()"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="dialogs.languageSkills.data.level"
                  label="Level*"
                  :disabled="dialogs.languageSkills.data.motherTongue"
                  :items="getCodeLabelSelectItems('langLevel')"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="dialogs.languageSkills.data.motherTongue"
                  label="Is Mother Tongue?"
                  color="companyPrimary"
                  @change="adjustLanguageLevel()"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="dialogs.languageSkills.data.language === ENGLISH_ID">
              <v-col>
                <v-select
                  v-model="dialogs.languageSkills.data.certification"
                  label="Certification*"
                  :items="getCodeLabelSelectItems('engCertificate')"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close_dialog_language_skills()">Cancel</v-btn>
        <v-btn
          :disabled="!formValidationLangSkill"
          color="info"
          text
          @click="add_item_language_skills()"
          >Add</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCodeLabelSelectItems } from "@/utils/enums";
import { validationRules } from "@/utils/validation-rules";

export default {
  name: "RegistrationAddLanguageSkillsDialog",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    languageSkills: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    "close-dialog-language-skills",
    "add-item-language-skills",
    "dialogs",
  ],
  data() {
    return {
      ENGLISH_ID: 6564,
      formValidationLangSkill: true,
      rules: { ...validationRules },
      getCodeLabelSelectItems,
    };
  },
  computed: {
    dialogs: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("dialogs", value);
      },
    },
  },
  methods: {
    close_dialog_language_skills() {
      this.$emit("close-dialog-language-skills");
    },
    add_item_language_skills() {
      this.$emit("add-item-language-skills");
    },
    getNotAlreadySelectedSkills() {
      let fullList = this.getCodeLabelSelectItems("langSkill");
      let currentArray = this.languageSkills;
      let prop = "language";

      if (currentArray.length == 0) return fullList;

      let uniqueSkillList = currentArray.map((el) => el[prop]);
      return fullList.filter((el) => !uniqueSkillList.includes(el.value));
    },
    checkLangCertificate() {
      if (this.dialogs.languageSkills.data.language !== this.ENGLISH_ID) {
        this.dialogs.languageSkills.data.certification = null;
      }
    },
    adjustLanguageLevel() {
      if (this.dialogs.languageSkills.data.motherTongue) {
        this.dialogs.languageSkills.data.level = 5;
      }
    },
  },
};
</script>
